import React from 'react';
import { connect } from 'react-redux';
import { StatisticsByReferralContent } from './StatisticsByReferralContent.js';
import { actions } from './StatisticsByReferralContent.actions';

const StatisticsByReferralContentComponent = connect(
    function mapStateToProps(state) {
        const storedMetrics = state?.statistics?.data?.parameters?.metricsBinary
            || state?.serverStorage?.store?.reportByReferral?.metrics;
        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page,
            metrics: typeof storedMetrics === 'string' ? storedMetrics : '',
            serverStorageReady: !!state.serverStorage.loaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            setQuery: actions.setQuery
        };
    }
)(StatisticsByReferralContent);

export default StatisticsByReferralContentComponent;
